<kendo-dialog-titlebar (close)="feche()">
  <h4 class="modal-title">
    <i class="fe-package mr-2"></i>
    <ng-container *ngIf="apresentacao.id">
      Unidade de compra {{apresentacao.id}} - {{apresentacao.descricao}}
    </ng-container>
    <ng-container *ngIf="!apresentacao.id">Nova unidade de compra</ng-container>
  </h4>
</kendo-dialog-titlebar>

<div class="modal-body">
  <div class="text-center p-4" *ngIf="carregando">
    <span class="spinner-border spinner-border-sm text-primary"></span>
    Carregando cadastro...
  </div>

  <kendo-tabstrip *ngIf="!carregando" (tabSelect)="selecioneAba($event)">
    <kendo-tabstrip-tab [title]="'Detalhes'" [selected]="abaSelecionada === 0">
      <ng-template kendoTabContent>
        <form novalidate #frm="ngForm" (ngSubmit)="onSalvar()"
              [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}">
    <div class="row">
      <div class="form-group col-12">
        <label for="descricaoApresentacao">Descrição</label>
        <input id="descricaoApresentacao" name="descricaoApresentacao" type="text"
               class="form-control" maxlength="120" autocomplete="off" required
               [(ngModel)]="apresentacao.descricao" appAutoFocus [autoFocus]="true"
               placeholder="Ex.: Fardo com 12 unidades">
        <small class="text-muted d-block mt-1">
          A mesma unidade de compra pode ser vinculada a vários insumos compatíveis.
          Prefira nomes genéricos que representem a embalagem e a conversão, como
          <b>Fardo com 12 unidades</b>, <b>Caixa com 24 unidades</b> ou <b>Saco de 5 kg</b>.
          Evite nomes específicos, como <b>Fardo de Água 500 ml</b>.
        </small>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-4">
        <label>Tipo de embalagem
          <i class="fas fa-info-circle text-blue" kendoTooltip
             title="Embalagem usada na compra ou recebimento. Ex.: para água comprada em fardos, selecione Fardo."></i>
        </label>
        <kendo-dropdownlist name="tipoEmbalagem" required
                            [(ngModel)]="apresentacao.tipoEmbalagem"
                            [data]="tiposEmbalagem" [textField]="'nome'"
                            class="form-control" style="border: none;">
        </kendo-dropdownlist>
      </div>

      <div class="form-group col-md-4">
        <label>Unidade-base
          <i class="fas fa-info-circle text-blue" kendoTooltip
             title="Unidade em que o insumo é controlado no estoque. Ex.: para um fardo com 12 águas, selecione UND."></i>
        </label>
        <kendo-dropdownlist name="unidadeBase" required
                            [(ngModel)]="apresentacao.unidadeBase"
                            [data]="unidades" [textField]="'nome'"
                            [disabled]="unidadeBaseBloqueada()"
                            class="form-control" style="border: none;">
        </kendo-dropdownlist>
        <small class="text-muted" *ngIf="unidadeBaseFixa">
          Unidade definida pelo insumo.
        </small>
        <small class="text-muted" *ngIf="!unidadeBaseFixa && apresentacao.totalVinculos > 0">
          Não pode ser alterada enquanto houver vínculos.
        </small>
      </div>

      <div class="form-group col-md-4">
        <label>Fator de conversão
          <i class="fas fa-info-circle text-blue" kendoTooltip
             title="Quantidade de unidades-base contidas em uma embalagem. Ex.: um fardo com 12 águas tem fator 12."></i>
        </label>
        <kendo-numerictextbox name="fatorConversao" required
                              [min]="0.000001" [decimals]="6" [format]="'n6'"
                              [(ngModel)]="apresentacao.fatorConversao"
                              class="form-control">
        </kendo-numerictextbox>
      </div>
    </div>

    <div class="conversao mb-3" *ngIf="apresentacao.unidadeBase && apresentacao.fatorConversao">
      Conversão: <b>1 unidade de compra = {{formateFator(apresentacao.fatorConversao)}}
      {{apresentacao.unidadeBase.sigla}}</b>
    </div>

    <div class="custom-control custom-checkbox mb-3">
      <input id="apresentacaoGlobalAtivaModal" name="apresentacaoGlobalAtivaModal"
             type="checkbox" class="custom-control-input"
             [(ngModel)]="apresentacao.ativa" [disabled]="!!unidadeBaseFixa">
      <label for="apresentacaoGlobalAtivaModal" class="custom-control-label">Ativa</label>
    </div>

    <div class="modal-footer">
      <p *ngIf="mensagemErro" class="text-danger mr-auto mb-0">
        <i class="mdi mdi-alert-circle-outline mr-1"></i>{{mensagemErro}}
      </p>
      <button type="submit" class="btn btn-primary waves-effect waves-light"
              [disabled]="!frm.dirty || salvando || !apresentacaoValida()">
        <i *ngIf="salvando" class="k-icon k-i-loading"></i>Salvar
      </button>
      <button type="button" class="btn btn-light waves-effect" (click)="feche()">
        Fechar
      </button>
    </div>
        </form>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab
      [title]="'Vínculos (' + (apresentacao.totalVinculosAtivos || 0) + ')'"
      [disabled]="!apresentacao.id" [selected]="abaSelecionada === 1">
      <ng-template kendoTabContent>
        <div class="pt-3">
          <div class="alert alert-danger" *ngIf="mensagemErroVinculos">
            {{mensagemErroVinculos}}
          </div>
          <div class="alert alert-success" *ngIf="mensagemSucessoVinculos">
            {{mensagemSucessoVinculos}}
          </div>

          <ng-container *ngIf="!adicionandoVinculos">
            <h4 class="mb-3">
              <b>{{apresentacao.totalVinculosAtivos || 0}}</b> insumo(s) associado(s) à
              unidade de compra "<b>{{apresentacao.descricao}}</b>"
            </h4>
            <h5>Lista de insumos vinculados à unidade de compra</h5>

            <kendo-grid class="grid-vinculos-unidade-compra"
                        [kendoGridBinding]="vinculos" (remove)="removaVinculo($event)"
                        [loading]="carregandoVinculos" [height]="500">
              <ng-template kendoGridToolbarTemplate [position]="'top'">
                <div class="row toolbar-vinculos">
                  <div class="col">
                    <button type="button" class="btn btn-blue float-right"
                            (click)="abraAdicaoVinculos()"
                            [disabled]="!apresentacao.ativa || carregandoVinculos">
                      <i class="fe-plus mr-1"></i>Adicionar Insumo
                    </button>
                  </div>
                </div>
              </ng-template>

              <kendo-grid-messages noRecords="Nenhum insumo vinculado"
                                   loading="Carregando"></kendo-grid-messages>

              <kendo-grid-column title="Código do insumo" [width]="110">
                <ng-template kendoGridCellTemplate let-vinculo>
                  <span [ngClass]="{'vinculo-removido': !vinculo.ativa}">
                    {{vinculo.insumo?.codigo || '-'}}
                  </span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Insumo" [width]="240">
                <ng-template kendoGridCellTemplate let-vinculo>
                  <b class="celula-truncada" kendoTooltip
                     [title]="vinculo.insumo?.nome || ''"
                     [ngClass]="{'vinculo-removido': !vinculo.ativa}">
                    {{vinculo.insumo?.nome}}
                  </b>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Unidade" [width]="80">
                <ng-template kendoGridCellTemplate let-vinculo>
                  {{vinculo.insumo?.unidadeMedida?.sigla || '-'}}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column title="Produto na fábrica" [width]="260"
                                 *ngIf="fornecimentoConfigurado">
                <ng-template kendoGridCellTemplate let-vinculo>
                  <span class="badge" [ngClass]="classeCorrespondencia(vinculo)"
                        kendoTooltip [title]="vinculo.correspondencia?.motivo || ''">
                    {{rotuloCorrespondencia(vinculo)}}
                  </span>
                  <small class="d-block text-muted text-truncate"
                         *ngIf="vinculo.correspondencia?.vinculo?.produto">
                    {{vinculo.correspondencia.vinculo.produto.codigo || '-'}} —
                    {{vinculo.correspondencia.vinculo.produto.nome}}
                  </small>
                  <small class="d-block text-muted text-truncate"
                         *ngIf="!vinculo.correspondencia?.vinculo?.produto && vinculo.codigoFornecedor">
                    Código informado: {{vinculo.codigoFornecedor}}
                  </small>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-command-column title="" [width]="fornecimentoConfigurado ? 100 : 60">
                <ng-template kendoGridCellTemplate let-vinculo>
                  <button type="button" kendoGridEditCommand kendoTooltip
                          title="Configurar produto na fábrica"
                          [disabled]="vinculo.salvando"
                          *ngIf="vinculo.ativa && fornecimentoConfigurado"
                          (click)="configureDePara(vinculo)">
                    <i class="fas fa-link"></i>
                  </button>
                  <button kendoGridRemoveCommand kendoTooltip title="Remover vínculo"
                          [disabled]="vinculo.salvando" *ngIf="vinculo.ativa">
                    <i class="fa fa-trash text-danger"></i>
                  </button>
                  <button type="button" class="btn btn-xs btn-warning" kendoTooltip
                          title="Desfazer remoção"
                          [disabled]="vinculo.salvando || !apresentacao.ativa"
                          *ngIf="!vinculo.ativa" (click)="restaureVinculo(vinculo)">
                    <i class="k-i-undo k-icon"></i>
                  </button>
                  <i class="k-i-loading k-icon" *ngIf="vinculo.salvando"></i>
                </ng-template>
              </kendo-grid-command-column>
            </kendo-grid>
          </ng-container>

          <ng-container *ngIf="adicionandoVinculos">
            <kendo-grid [kendoGridBinding]="candidatos"
                        [selectable]="{checkboxOnly: false, mode: 'multiple'}"
                        [(selectedKeys)]="idsInsumosSelecionados" kendoGridSelectBy="id"
                        (selectedKeysChange)="onSelectedKeysChange($event)"
                        [loading]="carregandoCandidatos" [height]="500">
              <ng-template kendoGridToolbarTemplate [position]="'top'">
                <div class="row">
                  <div class="col">
                    <button type="button" class="btn btn-success"
                            (click)="salveNovosVinculos()"
                            [disabled]="salvandoVinculos || !idsInsumosSelecionados.length">
                      <i class="fe-save mr-1"></i>
                      Salvar ({{idsInsumosSelecionados.length}})
                      <i class="k-icon k-i-loading" *ngIf="salvandoVinculos"></i>
                    </button>
                    <button type="button" class="btn btn-secondary ml-2"
                            (click)="volteParaVinculos()" [disabled]="salvandoVinculos">
                      <i class="fe-chevron-left mr-1"></i>Voltar
                    </button>
                  </div>
                </div>

                <div>
                  <div style="width: 240px">
                    <input style="width: 90%" kendoTextBox
                           placeholder="Busque por nome ou código do insumo"
                           class="form-control busca" [(ngModel)]="termoInsumo"
                           [ngModelOptions]="{standalone: true}"
                           (input)="onFilterInsumos($event)">
                  </div>
                  <div style="width: 190px">
                    <select class="form-control" [(ngModel)]="grupoFiltroId"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="carregueCandidatos()">
                      <option [ngValue]="null">Todos os grupos</option>
                      <option [ngValue]="0">Sem grupo</option>
                      <option *ngFor="let grupo of gruposFiltro" [ngValue]="grupo.id">
                        {{grupo.nome}}
                      </option>
                    </select>
                  </div>
                  <div class="custom-control custom-checkbox filtro-incompativeis">
                    <input id="exibirIncompativeis" type="checkbox"
                           class="custom-control-input"
                           [(ngModel)]="exibirIncompativeis"
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="carregueCandidatos()">
                    <label class="custom-control-label" for="exibirIncompativeis">
                      Exibir incompatíveis
                    </label>
                  </div>
                </div>
              </ng-template>

              <kendo-grid-messages
                                   [noRecords]="exibirIncompativeis ?
                                     'Nenhum insumo disponível' :
                                     'Nenhum insumo compatível disponível'"
                                   loading="Carregando"></kendo-grid-messages>
              <kendo-grid-checkbox-column [width]="72" [showSelectAll]="true">
                <ng-template kendoGridCellTemplate let-idx="rowIndex" let-insumo>
                  <input [kendoGridSelectionCheckbox]="idx"
                         [disabled]="insumo.vinculado || !insumo.compativel || !insumo.disponivelParaVinculo">
                  <i class="fa fa-info-circle text-warning ml-1" kendoTooltip
                     *ngIf="!insumo.compativel"
                     [title]="'Unidade incompatível. Necessário: ' + apresentacao.unidadeBase?.sigla"></i>
                  <i class="fa fa-info-circle text-warning ml-1" kendoTooltip
                     *ngIf="insumo.compativel && !insumo.disponivelParaVinculo"
                     title="Insumo indisponível para vínculo. Atualize a lista."></i>
                </ng-template>
              </kendo-grid-checkbox-column>
              <kendo-grid-column field="codigo" title="Código" [width]="110">
                <ng-template kendoGridCellTemplate let-insumo>
                  {{insumo.codigo || '-'}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="nome" title="Insumo"></kendo-grid-column>
              <kendo-grid-column title="Unidade" [width]="100">
                <ng-template kendoGridCellTemplate let-insumo>
                  {{insumo.unidadeMedida?.sigla || '-'}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="grupoNome" title="Grupo" [width]="170">
                <ng-template kendoGridCellTemplate let-insumo>
                  {{insumo.grupo?.nome || 'Sem grupo'}}
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </ng-container>

          <div class="modal-footer">
            <button type="button" class="btn btn-light" (click)="feche()"
                    [disabled]="salvandoVinculos">Fechar</button>
          </div>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>
